export class ImageViewerOptions {
    public width: number;
    public height: number;
    public marginTop: number;
    public marginLeft: number;
    public scaling: number;
    public rotation: number;
}
